import { defaultProps } from "helpers/common";
import { Link, LinkProps } from "@mui/material";

export type AppLinkProps = LinkProps;

function AppLink(props: AppLinkProps) {
    const linkProps = defaultProps(props, {
        sx: {
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
                textDecoration: "none",
            },
        },
    });

    return <Link {...linkProps} />;
}

export default AppLink;
